import { useUser } from '../auth/useAuth';
import React from 'react';
import { Btn } from '../components/chancey';
import { SupportPageLayout } from '../components/layout/SupportPageLayout';
import { TERMS } from '../data/supportContent';
import { useChanceyTheme } from '../theme/ThemeContext';
import { openFeedback } from '../utils/feedback';

const TermsPage: React.FC = () => {
  const { c, typ } = useChanceyTheme();
  const { user } = useUser();

  return (
    <SupportPageLayout title="Terms of service" eyebrow="Legal">
      <div
        className="text-[11px] font-semibold uppercase tracking-[0.1em]"
        style={{ color: c.inkMuted, fontFamily: typ.body }}
      >
        Last updated {TERMS.lastUpdated}
      </div>

      <p
        className="text-[14px] leading-relaxed"
        style={{ color: c.inkSoft, fontFamily: typ.body }}
      >
        {TERMS.intro}
      </p>

      <div className="flex flex-col gap-5">
        {TERMS.sections.map((section) => (
          <section key={section.heading} className="flex flex-col gap-1.5">
            <h2
              className="text-[17px] leading-tight"
              style={{
                fontFamily: typ.display,
                fontWeight: typ.displayWeight,
                letterSpacing: typ.displayLetter,
                color: c.ink,
              }}
            >
              {section.heading}
            </h2>
            {section.body.map((paragraph, i) => (
              <p
                key={i}
                className="text-[13.5px] leading-relaxed"
                style={{ color: c.inkSoft, fontFamily: typ.body }}
              >
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </div>

      <div
        className="mt-2 flex flex-col items-start gap-2 rounded-[18px] border p-4"
        style={{ background: c.surface, borderColor: c.line }}
      >
        <div className="text-sm" style={{ fontFamily: typ.body, color: c.ink, fontWeight: 600 }}>
          Questions about these Terms?
        </div>
        <Btn
          c={c}
          typ={typ}
          variant="ghost"
          onClick={() => openFeedback(user?.id)}
          style={{ alignSelf: 'stretch' }}
        >
          Contact us
        </Btn>
      </div>
    </SupportPageLayout>
  );
};

export default TermsPage;
